<template>

  <div>
<!--    <Filters-->
<!--        :role-filter.sync="roleFilter"-->
<!--        :plan-filter.sync="planFilter"-->
<!--        :status-filter.sync="statusFilter"-->
<!--        :role-options="roleOptions"-->
<!--        :plan-options="planOptions"-->
<!--        :status-options="statusOptions"-->
<!--    />-->
    <b-overlay :show="overlay">
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end actions-wrapper">
                <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Filtrar por nome, razão, CNPJ ou subdomínio..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button
                    variant="primary"
                    v-b-modal.modal-add-cliente-dkp
                    class="d-flex"
                >
                  <feather-icon
                      icon="PlusIcon"
                      class="mr-50"
                  />
                  <span class="align-middle">Cliente DKP</span>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refDataTableTemplateImagem"
            class="position-relative"
            :items="fetchDataAll"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  title="Editar"
                  variant="gradient-primary"
                  v-b-modal.modal-add-cliente-dkp
                  @click="editData(data.item)"
                  class="btn-icon mr-1"
              >
                <feather-icon icon="EditIcon" />
              </b-button>

              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  title="Deletar"
                  variant="gradient-danger"
                  @click="showModalDeleteTemplateImagem(data.item.id)"
                  class="btn-icon"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalTemplateImagem"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-imagem-home"
        title="Deletar Imagem"
        message="Tem certeza que deseja deletar?"
        btn-cancel-label="Cancelar"
        btn-ok-label="sim, deletar"
        @ok="deletedData"
        @cancel="isDeleteModal = false"
    />
    <modal-add-cliente-dkp
        v-model="isModalAddClienteDkp"
        @add-cliente-dkp="createOrUpdated($event)"
        @cancel="isModalAddClienteDkp = false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import ModalAddClienteDkp from '@/views/clientes-dkp/cliente/list/ModalAddClienteDkp.vue';
import store from '@/store';
import Filters from './Filters.vue';
import useList from './useList';

export default {
  components: {
    ModalAddClienteDkp,
    ModalConfirmation,
    Filters,
  },
  data() {
    return {
      searchInputValue: '',
    };
  },
  methods: {
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const isDeleteModal = ref(false);
    const isModalAddClienteDkp = ref(false);
    const isDataDeleted = ref(null);
    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      fetchDataAll,
      tableColumns,
      perPage,
      currentPage,
      totalTemplateImagem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableTemplateImagem,
      refetchData,
      overlay,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      createOrUpdated,
      deleteCliente,
      editCliente,
    } = useList();

    const showModalDeleteTemplateImagem = (id) => {
      isDataDeleted.value = id;
      isDeleteModal.value = true;
    };
    const deletedData = async () => {
      await deleteCliente(isDataDeleted.value);
      isDeleteModal.value = false;
      refetchData();
    };

    const editData = async (data) => {
      store.commit('sisDkpClientes/SET_DKP_CLIENTE', data);
    };

    return {
      fetchDataAll,
      // Sidebar
      isDeleteModal,
      tableColumns,
      perPage,
      currentPage,
      totalTemplateImagem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableTemplateImagem,
      refetchData,
      overlay,
      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      deletedData,
      showModalDeleteTemplateImagem,
      isModalAddClienteDkp,

      // CRUD
      createOrUpdated,
      deleteCliente,
      editCliente,
      editData,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
